import React from "react";

const calculateEndDate = (startDate, days=0, hours=0, minutes=0) => {
  // Create a Date object from the startDate
  let start = new Date(startDate);
  console.log(startDate, days)


  // Add days, hours, and minutes to the date
  start.setDate(start.getDate() + parseInt(days)); // Adding days
  start.setHours(start.getHours() + parseInt(hours)); // Adding hours
  start.setMinutes(start.getMinutes() + parseInt(minutes)); // Adding minutes

  const year = start.getFullYear();
  const month = String(start.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(start.getDate()).padStart(2, '0');
  const hour = String(start.getHours()).padStart(2, '0');
  const minute = String(start.getMinutes()).padStart(2, '0');

  // Create the formatted date string
  const formattedDate = `${year}-${month}-${day}T${hour}:${minute}`;

  return formattedDate;
};

export default calculateEndDate;
